import { filtersInitialState } from './filters.state';
import { FiltersActionsUnion, FiltersActionTypes } from './filters.actions';
import { Filters } from '../../models';

export function filtersReducer(state = filtersInitialState, action: FiltersActionsUnion) {
  switch (action.type) {
    case FiltersActionTypes.LOAD_FILTERS:
      return { ...state, loading: true };
    case FiltersActionTypes.RESET_FILTERS:
      return filtersInitialState;
    case FiltersActionTypes.LOAD_FILTERS_SUCCESS:
      return {
        ...state,
        payload: updateFilters(state.payload, action.payload.filters),
        loading: false,
        error: null,
      };
    case FiltersActionTypes.LOAD_FILTERS_FAILURE:
      return {
        ...state,
        payload: { ...filtersInitialState.payload },
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

function updateFilters(prevFilters: Filters, nextFilters: Filters): Filters {
  return {
    categories: nextFilters.categories || prevFilters.categories,
    categoriesNext: nextFilters.categoriesNext || [],
    priceRange: nextFilters.priceRange || prevFilters.priceRange,
    attributes: nextFilters.attributes || [],
    promotion: nextFilters.promotion || null,
    volumePrices: nextFilters.volumePrices || null,
    blackFriday: nextFilters.blackFriday || null,
  };
}
